import React from "react";
import { useTranslation } from "react-i18next";

export default function DoneStep() {
    const { t } = useTranslation();
    const tt = (key: string) => t(key, { ns: "translation" });

    return (
        <div className="text-center py-4">
            <h4 className="mb-2">{tt("pages.thermography.dataImportWizard.done.title")}</h4>
            <p className="text-muted mb-4">
                {tt("pages.thermography.dataImportWizard.done.description")}
            </p>
        </div>
    );
}
